module.exports = __webpack_public_path__ + "static/media/02-quote-01-carolina-herrera@2x.cddb1294.jpg";